import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { InvoiceStatusRule } from '../../../domain/models/invoice-status-rule.model';

@Component({
  selector: 'app-invoice-status-badge',
  templateUrl: './invoice-status-badge.component.html',
  styleUrls: ['./invoice-status-badge.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InvoiceStatusBadgeComponent {
  @Input({ required: true }) statusRule!: InvoiceStatusRule;
}
